import axios from 'axios';

const GEOCODING_API_URL = 'https://api.opencagedata.com/geocode/v1/json';
const API_KEY = process.env.REACT_APP_API_KEY;
//AIzaSyA1ECYYttTHTCexVeyhp1zb9IP9DhUoZLQ
const geocodeAddress = async (address) => {
    try {
        const response = await fetch("https://maps.googleapis.com/maps/api/geocode/json?address=" + encodeURIComponent(address) + "&key=AIzaSyA1ECYYttTHTCexVeyhp1zb9IP9DhUoZLQ");//fetch("https://api.geoapify.com/v1/geocode/search?text=" + encodeURIComponent(address) + "&limit=1&format=json&apiKey=da8e0d94d878401bbf3597f4c0fc93c5", { method: 'GET', redirect: "follow" })
        var data = await response.json();

        if (data.status === "OK") {
            return data;
        }
        
        return null;

    } catch (error) {
      return null;
  }
};

export default geocodeAddress;